// Vendors
import $ from 'jquery';

// Config
let map;
let marker;

// Init map
window.initMap = () => {
  map = new google.maps.Map(document.getElementById('map'), {
    center: window.initMarkerLocation,
    zoom: 15,
    scrollwheel: false
  });

  marker = new google.maps.Marker({
    position: window.initMarkerLocation,
    map
  });
};

const cf7forms = document.querySelector('.wpcf7-form');

if (cf7forms) {
  cf7forms.addEventListener('submit', (event) => {
    event.target.querySelector('.wpcf7-submit').disabled = true;
    event.target.querySelector('#spinner').style.display = 'block';
  });
}

function removeLoadingSpinner(event) {
  event.target.querySelector('.wpcf7-submit').disabled = false;
  event.target.querySelector('#spinner').style.display = 'none';
}

document.addEventListener('wpcf7submit', removeLoadingSpinner, false);
document.addEventListener('wpcf7invalid', removeLoadingSpinner, false);
